import { StyledContent } from "@/components/styles";
import { ElementCard } from "@/components";

const Elements = ({ data, videos }) => {
  return (
    <StyledContent.Cards type="elements" items={2}>
      {data.map((item, ind) => {
        const { title, content, image } = item.data;

        return <ElementCard key={ind} image={image} title={title} desc={content} video={videos[ind]} />;
      })}
    </StyledContent.Cards>
  );
};

export default Elements;
